import React, { useState, useEffect } from 'react';
import { StateContext } from './StateContext';
import { getEndpoints } from '../api/Api';
//import { ShowAlert } from '../components';
import { ACCESS_TOKEN, ADMIN_TOKEN, HR_TOKEN, CLIENT_TOKEN, FINANCIER_TOKEN, EMPLOYEE_TOKEN } from '../config/Config';


const initialState = {
  chat: false,
  cart: false,
  userProfile: false,
  notification: false,
};

export function ContextProvider({ children }) {
  const [screenSize, setScreenSize] = useState(undefined);
  const [currentColor, setCurrentColor] = useState('#0b77c2');
  const [currentMode, setCurrentMode] = useState('Light');
  const [themeSettings, setThemeSettings] = useState(false);
  const [activeMenu, setActiveMenu] = useState(false);
  const [isClicked, setIsClicked] = useState(initialState);
  const [contentEndpoints, setContentEndpoints] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [role, setRole] = useState('');
  const [language, setLanguage] = useState('EN');
  
  useEffect(() => {
    isAuthenticated();
    /*
    getEndpoints()
      .then((res) => {
        if (res.data === null) {
          //<ShowAlert message={res.message} type="error" />;
        } else {
          <ShowAlert message={res.message} type="success" />;
          setContentEndpoints(res.data);
        }
      })
      .catch((error) => {
        if (error.status === 401) {
          <ShowAlert
            message="Your are not eligible to access this endpoint"
            type="error"
          />;
        } else {
          <ShowAlert message={error.message} type="error" />;
        }
      });*/
  }, [role]);
   const isAuthenticated = () => {
      if (localStorage.getItem(ACCESS_TOKEN)) {
        let token = localStorage.getItem(ACCESS_TOKEN);
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace("-", "+").replace("_", "/");
        token = JSON.parse(window.atob(base64));
        if (token.exp <= Math.floor(Date.now() / 1000)) {
          localStorage.removeItem(ACCESS_TOKEN);
          localStorage.removeItem(ADMIN_TOKEN);
          setIsLoggedIn(false);
        }
        //CHECK IF USER HAS ROLE_ADMIN
        if (token.rol.length >= 1) {
          if (token.rol[0] && token.rol[0] === "ADMIN") {
            localStorage.setItem(ADMIN_TOKEN, token.rol[0]);
            setRole(token.rol[0]);
          }
          setRole(token.rol[0]);
          return true;
        } else {
          return false;
        }
      }
    };
  const setMode = (e) => {
    setCurrentMode(e.target.value);
    localStorage.setItem('themeMode', e.target.value);
  };

  const setColor = (color) => {
    setCurrentColor(color);
    localStorage.setItem('colorMode', color);
  };

  
  const handleClick = (clicked) => setIsClicked({ ...initialState, [clicked]: true });

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <StateContext.Provider
      value={{
        currentColor,
        currentMode,
        activeMenu,
        screenSize,
        setScreenSize,
        handleClick,
        isClicked,
        initialState,
        setIsClicked,
        setActiveMenu,
        setCurrentColor,
        setCurrentMode,
        setMode,
        setColor,
        themeSettings,
        setThemeSettings,
        contentEndpoints,
        setIsLoggedIn,
        isLoggedIn,
        role,
        setRole,
        language,
        setLanguage
      }}
    >
      {children}
    </StateContext.Provider>
  );
}
